import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { avisarError, Campo, cargar, sucursalActual, Tarjeta, tokenOperacion } from '../comun';

const Devolucion = ({ history, match }) => {
    const { id } = match.params;
    const { changeGlobalTitle } = useUIUtils();
    const [venta, setVenta] = useState(null);
    const [formas, setFormas] = useState([]);
    const [lineas, setLineas] = useState([]);
    const [cobros, setCobros] = useState([{ forma_Cobro_Id: '', importe: 0 }]);
    const [cajaId, setCajaId] = useState('');
    const [cajeroId, setCajeroId] = useState('');
    const [descripcion, setDescripcion] = useState('Devolucion de mostrador');
    const lista = match.url.replace(/\/devolucion\/.*$/, '');

    useEffect(() => {
        changeGlobalTitle('Devolucion', `Venta ${id}`);
        fetchConToken(`pv/PvDocumentos?id=${id}`).then((response) => {
            if (avisarError(response)) return;
            setVenta(response);
            setCajaId(response.caja_Id || '');
            setCajeroId(response.cajero_Id || '');
            setLineas((response.detalle || []).map((item) => ({
                detalle_Id: item.id,
                clave: item.clave_Articulo || item.articulo_Id,
                disponibles: Number(item.unidades || 0) - Number(item.unidades_Devueltas || 0),
                unidades: 0
            })));
        });
        cargar('pv/PvFormasCobros/GetList?paginas=0&totalXpagina=200&busqueda=').then(setFormas);
    }, [changeGlobalTitle, id]);

    function devolver(event) {
        event.preventDefault();
        fetchConToken('pv/PvDocumentos/Devolucion', {
            venta_Id: Number(id),
            sucursal_Id: Number(sucursalActual()),
            caja_Id: Number(cajaId),
            cajero_Id: Number(cajeroId),
            descripcion,
            idempotency_Token: tokenOperacion('dev'),
            detalle: lineas.filter((item) => Number(item.unidades) > 0).map((item) => ({
                detalle_Id: item.detalle_Id,
                unidades: Number(item.unidades)
            })),
            cobros: cobros.filter((item) => item.forma_Cobro_Id).map((item) => ({
                forma_Cobro_Id: Number(item.forma_Cobro_Id),
                importe: Number(item.importe),
                tipo_Cambio: 1,
                moneda: 'MXN'
            }))
        }, 'POST').then((response) => {
            if (avisarError(response)) return;
            Swal.fire('Exito', `Devolucion ${response.folio || ''} registrada`, 'success');
            history.push(`${lista}/ver/${response.id}`);
        }).catch(alertService.error);
    }

    return (
        <div className='container-fluid'>
            <form onSubmit={devolver}>
                <div className='mb-3'><Link to={lista} className='btn btn-outline-warning'>Regresar</Link></div>
                <Tarjeta titulo={`Devolver venta ${venta?.folio || id}`}>
                    <div className='row'>
                        <div className='col-md-3'><Campo label='Caja'><input className='form-control' required value={cajaId} onChange={({ target }) => setCajaId(target.value)} /></Campo></div>
                        <div className='col-md-3'><Campo label='Cajero'><input className='form-control' required value={cajeroId} onChange={({ target }) => setCajeroId(target.value)} /></Campo></div>
                        <div className='col-md-6'><Campo label='Descripcion'><input className='form-control' value={descripcion} onChange={({ target }) => setDescripcion(target.value)} /></Campo></div>
                    </div>
                    <table className='table table-sm'>
                        <thead><tr><th>Articulo</th><th>Disponibles</th><th>A devolver</th></tr></thead>
                        <tbody>
                            {lineas.map((item, index) => (
                                <tr key={item.detalle_Id}>
                                    <td>{item.clave}</td>
                                    <td>{item.disponibles}</td>
                                    <td>
                                        <input type='number' className='form-control' min='0' max={item.disponibles} value={item.unidades} onChange={({ target }) => {
                                            const copia = [...lineas];
                                            copia[index] = { ...copia[index], unidades: target.value };
                                            setLineas(copia);
                                        }} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {cobros.map((item, index) => (
                        <div className='row' key={index}>
                            <div className='col-md-6'>
                                <Campo label='Forma de reembolso'>
                                    <select className='form-select' value={item.forma_Cobro_Id} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], forma_Cobro_Id: target.value };
                                        setCobros(copia);
                                    }}>
                                        <option value=''>Seleccione</option>
                                        {formas.map((forma) => <option key={forma.id} value={forma.id}>{forma.nombre}</option>)}
                                    </select>
                                </Campo>
                            </div>
                            <div className='col-md-3'>
                                <Campo label='Importe'>
                                    <input type='number' className='form-control' value={item.importe} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], importe: target.value };
                                        setCobros(copia);
                                    }} />
                                </Campo>
                            </div>
                        </div>
                    ))}
                    <button type='submit' className='btn btn-outline-success'>Registrar devolucion</button>
                </Tarjeta>
            </form>
        </div>
    );
};

export { Devolucion };
